import type { FluxErrorEntityErrorCodes } from '../../types.js';

export const AutomationV2ExecutionActionAddCustomVariableCodes = {
  AutomationV2ExecutionActionAddCustomVariableEmptyKey: {
    code: 'automation-v2-execution-action/add-custom-variable-empty-key',
    explanation: `Chave da variável personalizada não fornecida.

**Causas comuns:**
- Campo de chave deixado em branco
- O resultado da interpolação é uma string vazia

**Como resolver:**
Forneça uma chave válida para a variável personalizada. Ou garanta que a interpolação resulte em um valor não vazio.`,
    localizations: {},
    message: 'A chave da variável personalizada não pode estar vazia.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Variável Personalizada',
        path: '/wiki/docs/automations/actions/add-custom-variables',
      },
    ],
  },
  AutomationV2ExecutionActionAddCustomVariableInvalidValue: {
    code: 'automation-v2-execution-action/add-custom-variable-invalid-value',
    explanation: `Valor da variável personalizada não suportado.

**Causas comuns:**
- Valor muito grande
- No caso de tipos complexos (objetos, arrays), o formato está incorreto ou o JSON é inválido
- O valor não pôde ser convertido para o tipo esperado e o comportamento não é de falha silenciosa

**Como resolver:**
Ajuste o valor para que esteja dentro dos limites aceitáveis e no formato correto para o tipo de dado esperado.
> Caso queira ignorar erros de conversão, altere a configuração definida em \`invalid_value_behavior\`.\n`,
    localizations: {},
    message: 'O valor da variável personalizada é inválido.',
    supportingDocs: [
      {
        name: 'Ação de Adicionar Variável Personalizada',
        path: '/wiki/docs/automations/actions/add-custom-variables',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'automation-v2-execution-action'>;
